import { useDataValue } from 'Simple/Data.js'

let TIMELINE_EVENTS_TYPES = {
  APPOINTMENT: 'appointment',
  CUSTOM_RESOURCE: 'custom_resource',
  NOTE: 'note',
  ORDER: 'order',
  TREATMENT_STATUS_CHANGE: 'treatment_status_change',
}

function useOnCreateWhereClause(props) {
  let presets = useDataValue({
    context: 'user_preferences',
    path: 'timeline_filter_presets',
    viewPath: props.viewPath,
  })

  if (!presets?.length) {
    return {
      type: {
        _in: [
          TIMELINE_EVENTS_TYPES.NOTE,
          TIMELINE_EVENTS_TYPES.APPOINTMENT,
          TIMELINE_EVENTS_TYPES.TREATMENT_STATUS_CHANGE,
          TIMELINE_EVENTS_TYPES.CUSTOM_RESOURCE,
          TIMELINE_EVENTS_TYPES.ORDER,
        ],
      },
    }
  }

  return (
    presets
      // only generate the filter with enabled types
      .filter(item => item.value)
      .reduce(
        (acc, item) => {
          if (item.custom_resource) {
            if (!acc._or?.[1].custom_resource) {
              acc = {
                _or: [
                  { ...acc },
                  {
                    custom_resource: {
                      type: { _in: [] },
                    },
                  },
                ],
              }
            }
            if (!acc._or[1].custom_resource.type['_in'].includes(item.id)) {
              acc._or[1].custom_resource.type['_in'].push(item.id)
            }
          } else if (acc._or?.length) {
            if (!acc._or[0].type['_in'].includes(item.id)) {
              acc._or[0].type['_in'].push(item.id)
            }
          } else if (!acc.type['_in'].includes(item.id)) {
            acc.type['_in'].push(item.id)
          }

          return acc
        },
        { type: { _in: ['treatment_status_change'] } }
      )
  )
}

export default function useDataConfiguration(props) {
  let treatment_id = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'treatment_id',
  })

  let where = useOnCreateWhereClause(props)

  return {
    variables: {
      treatment_id,
      where,
    },
    pause: !treatment_id,
    requestPolicy: 'cache-and-network',
  }
}
